import { createCsrfToken, createPutRequestOpts, fetchJsonQuery } from "@mne-core/api";
import type { IRequestOpts, IResultstash } from "@mne-core/api";
import { QueryController, createUrl } from "@mne-core/api";

export interface IFetchBreachStatusCriteria {
  password: string;
}

export interface IFetchBreachStatusResponse {
  state: "ok" | "breached";
  breachCount: number;
}

export const createRequest = ({ ...restCriteria }: IFetchBreachStatusCriteria, opts: IRequestOpts): Request => {
  const { apiUrl, sessionKey, ...restOpts } = opts;
  const uri = createUrl(apiUrl, ["authentication", "v1", "password", "test"]).toString();
  return new Request(
    uri,
    createPutRequestOpts(JSON.stringify(restCriteria), { ...restOpts, csrfToken: createCsrfToken(sessionKey, uri) }),
  );
};

export const fetchBreachStatusByCriteria = async (criteria: IFetchBreachStatusCriteria, opts: IRequestOpts) =>
  fetchJsonQuery<IResultstash<IFetchBreachStatusResponse>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
